module.exports = __webpack_public_path__ + "img/The_Grosvenor.574ff664.jpg";